import { useState, useCallback } from 'react';
import i18next from 'i18next';

import { searchVehicles as baseSearchVehicles, SearchV2Result } from 'lib/AutolistAPI';
import { SrpFilterApiParams } from 'lib/srpFilterTransformers';

export type UseSearchVehiclesResult = [SearchVehicles, UseSearchVehiclesState];

export type SearchVehicles = (params: SrpFilterApiParams) => Promise<void>;

export interface UseSearchVehiclesState {
  isPending: boolean;
  error?: unknown;
  data: SearchV2Result;
  hasFetchedOnce: boolean;
}

export default function useSearchVehicles(): UseSearchVehiclesResult {
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState<unknown>();
  const [data, setData] = useState<SearchV2Result>({ vehicles: [], totalCount: 0, adInfo: null });
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false);

  const searchVehicles = useCallback(async (params: SrpFilterApiParams) => {
    try {
      setIsPending(true);
      setError(null);
      const d = await baseSearchVehicles({
        locale: i18next.language,
        ...params,
      });
      setData(d);
      setIsPending(false);
    } catch (err) {
      setIsPending(false);
      setError(err);
    } finally {
      setHasFetchedOnce(true);
    }
  }, []);

  return [searchVehicles, { isPending, error, data, hasFetchedOnce }];
}
